import { ActionTypes } from "../contants/Action.Type";
const initialState = {
  Products: [],
  FilterProduct: [],
  Category: [],
};
export const productReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_PRODUCTS:
      return { ...state, Products: payload.Products };
    case ActionTypes.SET_FILTER_PRODUCT:
      return { ...state, FilterProduct: payload.Products };
    case ActionTypes.SET_PRODUCT_CATEGORY:
      return { ...state, Category: payload.Category };
    default:
      return state;
  }
};
